import { Component, Input } from '@angular/core';
import { Status as StatusType } from './status.model';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'uw-status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls: ['./status-indicator.component.scss'],
    imports: [MatIcon]
})
export class StatusIndicatorComponent {

  @Input()
  status!: string;

  StatusType = StatusType;

}
